export var PaymentCreditSources;
(function (PaymentCreditSources) {
    PaymentCreditSources["MANUAL"] = "MANUAL";
    PaymentCreditSources["SUBSCRIPTION"] = "SUBSCRIPTION";
    PaymentCreditSources["REGISTRATION"] = "REGISTRATION";
})(PaymentCreditSources || (PaymentCreditSources = {}));
//# sourceMappingURL=constants.js.map